export const SYSTEM_ROW_ID_FIELD_NAME = '_oxen_id';

export const DIFF_STATUS_FIELD_NAME = '_oxen_diff_status';
// export const DIFF_HASH_FIELD_NAME = '_oxen_diff_hash';
export const DERRIVED_INDEX_FIELD_NAME = '_oxen_row_id';

export const SYSTEM_ADDED_COLUMNS = ['_oxen_diff_status', '_oxen_diff_hash', '_oxen_id', '_oxen_row_id'];
export const SCHEMA_DISPLAY_FIELD_NAME_BLACKLIST = [
  '_oxen_diff_hash',
  '_oxen_id',
  '_oxen_row_id',
  '_oxen_diff_status',
  '_oxen_eval_status',
  '_oxen_eval_error',
  '_oxen_eval_duration',
];
export const GRID_DISPLAY_FIELD_NAME_BLACKLIST = [
  '_oxen_diff_hash',
  '_oxen_id',
  '_oxen_eval_status',
  '_oxen_eval_error',
  '_oxen_eval_duration',
];

export const EDITABLE_RENDER_METHOD_WHITELIST = ['int', 'float', 'bool', 'str', 'markdown', 'code'];
export const EDITABLE_FIELD_NAME_BLACKLIST = ['_oxen_diff_status', '_oxen_id', '_oxen_row_id'];
